import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { ConfigService } from "../../../../config/config.service";
import { ClientService } from "../../../shared/client/client.service";
import { Passage, PassageLod } from "./passage";

@Injectable({
  providedIn: "root"
})
export class PassageService {

  constructor(
    private clientService: ClientService,
    private configService: ConfigService,
    private http: HttpClient
  ) {
  }

  getPassages(): Observable<Array<Passage>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.clientService.getFirstCurrentClient().pipe(
          mergeMap(client => {
            return this.http.get<Array<Passage>>(config.apiPoint + config.getClientDeliveriesTournees.replace("{client}", client.id));
          }));
      }));
  }
}
